module.exports = __webpack_public_path__ + "media/icons/link-arrow-d8c74a7b736acd2d4f35085efbadb195.svg";